/** TikTok daily rows are date buckets; include complete UTC calendar days. */
export function reportWindow(days: number, now = new Date()) {
  const end = new Date(now);
  end.setUTCHours(23, 59, 59, 999);
  const start = new Date(end);
  start.setUTCDate(start.getUTCDate() - days + 1);
  start.setUTCHours(0, 0, 0, 0);
  const previous = new Date(start);
  previous.setUTCDate(previous.getUTCDate() - days);
  return { from: start.toISOString(), to: end.toISOString(), previousFrom: previous.toISOString() };
}
